import {FC, PropsWithChildren, useCallback, useEffect, useMemo, useRef, useState} from 'react'
import {toastMessage} from '../Toast'
import {IOnlineWatcherContext, OnlineWatcherContext} from './OnlineWatcher.context'

export const OnlineWatcherProvider: FC<PropsWithChildren> = ({children}) => {
  const [isOnline, setIsOnline] = useState(navigator.onLine)

  const intervalTimer = useRef<NodeJS.Timeout | null>(null)

  const notifyMessageId = useRef<string | null>(null)

  const checkOnlineState = useCallback(() => {
    if (!navigator.onLine) {
      if (isOnline) {
        setIsOnline(false)
      }

      if (!notifyMessageId.current) {
        notifyMessageId.current = toastMessage.error('Ingen internettforbindelse', {
          duration: 86400,
        })
      }
    } else {
      setIsOnline(true)

      if (notifyMessageId.current) {
        toastMessage.dismiss(notifyMessageId.current)
        notifyMessageId.current = null

        toastMessage.success('Koblet til internett', {
          duration: 2000,
        })
      }
    }
  }, [isOnline])

  useEffect(() => {
    intervalTimer.current = setInterval(checkOnlineState, 1000)

    return () => {
      if (intervalTimer.current) {
        clearInterval(intervalTimer.current)
      }
    }
  }, [])

  const OnlineWatcherContextValue: IOnlineWatcherContext = useMemo(
    () => ({
      isOnline,
    }),
    [isOnline],
  )

  return (
    <OnlineWatcherContext.Provider value={OnlineWatcherContextValue}>
      {children}
      {!isOnline && (
        <div className="pointer-events-auto fixed inset-0 z-[9999] bg-slate-900 bg-opacity-50"></div>
      )}
    </OnlineWatcherContext.Provider>
  )
}
